import {Map, fromJS, List} from "immutable";

import {FETCH_EVENTS_REQUEST, FETCH_EVENTS_SUCCESS, FETCH_EVENTS_ERROR} from "./audit-actions"

const audit = (state = Map({
    payload: List([]),
    isFetching: false,
    error: false
}), action) => {
    let newState;
    switch (action.type) {

        // Requests
        case FETCH_EVENTS_REQUEST:
            newState = state.merge({
                isFetching: true,
                error: false
            });
            return newState;

        // Success
        case FETCH_EVENTS_SUCCESS:
            newState = state.merge({
                payload: fromJS(action.payload),
                isFetching: false,
                error: false
            });
            return newState;

        // Errors
        case FETCH_EVENTS_ERROR:
            newState = state.merge({
                isFetching: false,
                error: action.error,
                errorMessage: action.errorMessage
            });
            return newState;
        default:
            return state;
    }
};

export default audit;